import * as Emotion from 'emotion';

export const horizontalDivider = Emotion.css`
  width: 100%;
  height: 1px;
  border-bottom: 1px solid rgba(0, 40, 100, 0.12);
`;
